import React, { useEffect, useState } from "react";
import { Input } from "@mui/material";
import api from "../Axios/api";
import moment from "moment";
import { useSelector } from "react-redux";
import { Ban } from "lucide-react";
import Select from "react-select";
import Swal from "sweetalert2";

const CustomOption = (props) => {
  const { data, innerRef, innerProps, isFocused, isSelected } = props;

  const handleDeleteClick = async (e) => {
    e.stopPropagation();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to close PO: ${data.label}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, close it!",
    });

    if (result.isConfirmed) {
      try {
        await api.patch(`/po-detail/close-status/${data.value}`);

        Swal.fire({
          icon: "success",
          title: "PO status closed",
          text: `PO ${data.label} has been successfully closed.`,
          timer: 1000,
          showConfirmButton: false,
        });
      } 
      catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error closing PO",
          text: error.response?.data?.message || "Something went wrong.",
        });
      }
    }
  };

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={`flex items-center justify-between px-3 py-2 cursor-pointer ${
        isFocused ? "bg-gray-100" : ""
      } ${isSelected ? "font-semibold" : ""}`}
    >
      <span>{data.label}</span>

      {data.label !== "Cash" && (
        <Ban
          size={18}
          className="text-red-500 hover:text-red-700"
          onClick={handleDeleteClick}
        />
      )}
    </div>
  );
};

function ReceiptPartyDetail({
  formState,
  setFormState,
  orderDateDropDown,
  poNoDropdown,
  setPoNoDropdown,
  receiptId,
}) {
  const userRole = useSelector((state) => state.user.staff_role);
  const currentStaffFacLoc = useSelector((state) => state.user.staff_FacLoc);
  // It is purchase status dropdown value
  const statusOptions = [
    { label: "Accepted", value: "Accepted" },
    { label: "Rejected", value: "Rejected" },
  ];

  // All Dropdown States
  const [staffNameDropdown, setStaffNameDropdown] = useState([]);
  const [vendorDropdown, setVenderDropdown] = useState([]);
  const [ledgerDropdown, setLedgerDropdown] = useState([]);
  const [poBranch, setpoBranch] = useState(null);

  const staffNameList = async () => {
    await api
      .get(`/staff/get-staff-name`)
      .then((res) => {
        const newData = res.data.map((staff, index) => {
          return { value: staff._id, label: staff.staff_name };
        });
        setStaffNameDropdown(newData);
      })
      .catch((err) => console.log(err));
  };

  const getVenderList = async () => {
    await api
      .get(`/vendor/get-name`)
      .then((res) => {
        const newData = res.data.map((vendor, index) => {
          return { value: vendor._id, label: vendor.vendor_name };
        });
        setVenderDropdown(newData);
      })
      .catch((err) => console.log(err));
  };

  const get_ledger = async () => {
    try {
      const res = await api.get(`/purchase-ledger/get-all`);
      const data = res.data;

      const newData = data.purchaseLedger
        .filter((item) => {
          return item.purchase_ledger_factory === poBranch[0];
        })
        .map((item) => ({
          label: item.purchase_ledger_name,
          value: item._id,
        }));
      setLedgerDropdown(newData);
    } catch (error) {
      console.log(error);
    }
  };

  const getPoNumberList = async (partyId) => {
    try {
      const res = await api.get(`/receipt-note/get-po-numbers/${partyId}`);
      const filteredPoNumbers = res.data.filter((PoNum) => {
        if (PoNum.po_status !== 1) return false;
          const selectedDate = formState.entry_date;
          const poDate = PoNum.po_date.split("T")[0];
           if  (selectedDate && poDate > selectedDate)  {
            return false; 
          }
        if (userRole === "666c0f8ebeca5ab2c65b35a9") {
          return true;
        }
        return PoNum.po_indent_branch === currentStaffFacLoc;
      });

      const newData1 = filteredPoNumbers.map((PoNum) => ({
        value: PoNum._id,
        label: PoNum.po_number,
        factory: PoNum.po_indent_branch,
        status: PoNum.po_status
      }));
      setPoNoDropdown([
        {
          value: null,
          label: "Cash",
        },
        ...newData1,
      ]);
    } catch (error) {
      console.error("Error fetching PO numbers:", error);
    }
  };
  useEffect(() => {
  if (formState.entrydate && formState.party_id) {
    getPoNumberList(formState.party_id);
  }
}, [formState.entrydate]);

  useEffect(() => {
    staffNameList();

    getVenderList();
  }, []);
  useEffect(() => {
    get_ledger();
  }, [poBranch]);

  useEffect(() => {
    let order_date = orderDateDropDown.find((option) =>
      formState.order_date.map((val) => option.value === val)
    );
    if (order_date?.value) {
      setFormState((prev) => ({
        ...prev,
        order_date: [...prev.order_date, order_date.value], // Avoid duplicates in po_number
      }));
    }
  }, [orderDateDropDown]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div className="flex flex-col">
        <label className="mb-2 font-semibold text-gray-700">
          Receipt No. <span className="text-red-500">*</span>
        </label>
        <Input
          type="text"
          multiple
          name="receipt_no"
          value={formState.receipt_no}
          onChange={(e) => {
            setFormState((prev) => ({ ...prev, receipt_no: e.target.value }));
          }}
          className="block w-full rounded border-0 py-1 pl-7 pr-10 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset   sm:text-sm sm:leading-6"
          placeholder="Receipt No."
        />
      </div>

      <div className="flex flex-col">
        <label className="mb-2 font-semibold text-gray-700">
          Date <span className="text-red-500">*</span> 
        </label>
        <input
          type="date"
          name="entry_date"
          value={formState.entry_date}
          onChange={(e) => {
            e.target.value <= moment().format("yyyy-MM-DD") &&
              setFormState((prev) => ({ ...prev, entry_date: e.target.value }));
               getPoNumberList();
          }}
          className="block w-full rounded border-0 py-1.5 pl-7 pr-10 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset   sm:text-sm sm:leading-6"
        />
      </div>

      <div className="flex flex-col">
        <label className="mb-2 font-semibold text-gray-700">
          Select Staff <span className="text-red-500">*</span>
        </label>
        <Select
          options={staffNameDropdown}
          value={
            staffNameDropdown.find(
              (option) => option.value === formState.staff_id
            ) || null
          }
          onChange={(e) => {
            setFormState((prev) => ({ ...prev, staff_id: e.value }));
          }}
          styles={{
            menuList: () => ({
              overflowY: "scroll",
              maxHeight: "200px",
            }),
            input: (baseStyles) => ({
              ...baseStyles,
              width: "180px",
            }),
            placeholder: (baseStyles) => ({
              ...baseStyles,
            }),
          }}
        />
      </div>

      <div className="flex flex-col">
        <label className="mb-2 font-semibold text-gray-700">
          Party Name <span className="text-red-500">*</span>
        </label>
        <Select
          isDisabled={receiptId && true}
          options={vendorDropdown}
          value={
            vendorDropdown.find(
              (option) => option.value === formState.party_id
            ) || null
          }
          onChange={(e) => {
            setFormState((prev) => ({ ...prev, party_id: e.value }));
            getPoNumberList(e.value);
          }}
          styles={{
            menuList: () => ({
              overflowY: "scroll",
              maxHeight: "200px",
            }),
            input: (baseStyles) => ({
              ...baseStyles,
              width: "180px",
            }),
            control: (base) => ({
              ...base,
              backgroundColor: receiptId && "#E2E8F0",
            }),
            singleValue: (base, state) => ({
              ...base,
              color: state.isDisabled ? "black" : "#1A202C",
            }),
          }}
        />
      </div>

      <div className="flex flex-col">
        <label className="mb-2 font-semibold text-gray-700">
          PO Number <span className="text-red-500">*</span>
        </label>
        <Select
          isDisabled={receiptId && true}
          options={poNoDropdown}
          value={poNoDropdown?.filter((dropdown) =>
            formState.po_id.includes(dropdown.value)
          )}
          isMulti
          onChange={(selectedOptions) => {
            const selectedPoIds = selectedOptions.map((option) => option.value);
            const po_branch = selectedOptions.map((option) => option.factory);
            setpoBranch(po_branch);
            const selectedPoNumbers = selectedOptions.map(
              (option) => option.label
            );

            if (selectedOptions.length > 0) {
              setFormState((prev) => ({
                ...prev,
                po_id: [...new Set(selectedPoIds)],
                po_number: [...new Set(selectedPoNumbers)],
              }));
            } else {
              setFormState((prev) => ({ ...prev, po_id: [], po_number: [] }));
            }
          }}
          components={{ Option: CustomOption }}
          styles={{
            menuList: () => ({
              overflowY: "scroll",
              maxHeight: "200px",
            }),
            input: (baseStyles) => ({
              ...baseStyles,
              width: "180px",
            }),
            control: (base) => ({
              ...base,
              backgroundColor: receiptId && "#E2E8F0",
            }),
            singleValue: (base, state) => ({
              ...base,
              color: state.isDisabled ? "black" : "#1A202C",
            }),
          }}
        />
      </div>

      <div className="flex flex-col">
        <label className="mb-2 font-semibold text-gray-700">
          Purchase Ledger <span className="text-red-500">*</span>
        </label>

        <Select
          isDisabled={receiptId && true}
          options={ledgerDropdown}
          placeholder={formState.purchase_ledger_name || "please select..."}
          value={
            ledgerDropdown.find(
              (option) => option.value === formState.purchase_ledger
            ) || null
          }
          onChange={(e) => {
            setFormState((prev) => ({ ...prev, purchase_ledger: e.value }));
          }}
          styles={{
            menuList: () => ({
              overflowY: "scroll",
              maxHeight: "200px",
            }),
            input: (baseStyles) => ({
              ...baseStyles,
              width: "180px",
            }),
            control: (base) => ({
              ...base,
              backgroundColor: receiptId && "#E2E8F0",
            }),
            singleValue: (base, state) => ({
              ...base,
              color: state.isDisabled ? "black" : "#1A202C",
            }),
          }}
        />
      </div>

      <div className="flex flex-col">
        <label className="mb-2 font-semibold text-gray-700">
          Order Date <span className="text-red-500">*</span>
        </label>
        <Select
          isDisabled={receiptId && true}
          options={orderDateDropDown}
          value={orderDateDropDown.find((option) =>
            formState.order_date.map((val) => option.value === val)
          )}
          isMulti
          // onChange={(selectedOptions) => {
          //     const selectedValues = selectedOptions.map(option => option.value);
          //     console.log("selected", selectedValues);
          //     // selectedOptions.length > 0 ? setFormState((prev) => ({
          //     //     ...prev, order_date: [...prev.order_date, ...selectedValues.filter(val => !prev.order_date.includes(val))]
          //     // })) : setFormState((prev) => ({ ...prev, order_date: [] }));
          // }}
          styles={{
            menuList: () => ({
              overflowY: "scroll",
              maxHeight: "200px",
            }),
            input: (baseStyles) => ({
              ...baseStyles,
              width: "180px",
            }),
            control: (base) => ({
              ...base,
              backgroundColor: receiptId && "#E2E8F0",
            }),
            singleValue: (base, state) => ({
              ...base,
              color: state.isDisabled ? "black" : "#1A202C",
            }),
          }}
        />
      </div>

      <div
        className={`flex flex-col ${
          formState.receipt_status === "Rejected" && "bg-red-400"
        }`}
      >
        <label className="mb-2 font-semibold text-gray-700">
          Purchase Status <span className="text-red-500">*</span>
        </label>
        <Select
          options={statusOptions}
          value={
            statusOptions.find(
              (option) => option.value === formState.receipt_status
            ) || null
          }
          onChange={(selectedOption) =>
            setFormState((prev) => ({
              ...prev,
              receipt_status: selectedOption.value,
            }))
          }
          styles={{
            menuList: () => ({
              overflowY: "scroll",
              maxHeight: "200px",
            }),
            input: (baseStyles) => ({
              ...baseStyles,
              width: "180px",
            }),
            placeholder: (baseStyles) => ({
              ...baseStyles,
            }),
          }}
        />
      </div>
    </div>
  );
}

export default ReceiptPartyDetail;
